<template>
  <vbt-content-box title="Information">
    <order-reference-search-box
      v-model="searchTerm"
      @submit="getReshipOrder"
    />

    <v-layout class="mt-5">
      <v-flex sm6>
        <v-select
          v-model="printProviderId"
          :disabled="providers.length < 2"
          :items="providers"
          label="Print provider"
        />
      </v-flex>
    </v-layout>

    <order-form
      v-if="showOrderForm"
      :order="reshipOrder"
      :order-creator="createReshipOrder"
      :need-order-items="false"
      need-package-items
      address-label="To"
      address-key="to"
      @submit="sendReshipOrder"
      @reset="resetForm"
    />

    <shipping-labels-viewer
      v-if="returnedLabels.shippingLabels.length"
      :labels="returnedLabels.shippingLabels"
    />
  </vbt-content-box>
</template>

<script>
import {
  mapState,
  mapMutations,
  mapActions,
  mapGetters,
} from 'vuex';

import { wrapToLoadingFn } from '@helpers';

import { ReshipApiService } from '../_services/reship.api.service';

import { createReshipOrder } from '../_meta/reshipOrder';

import OrderForm from '../../_components/OrderForm';
import ShippingLabelsViewer from '../../_components/ShippingLabelsViewer.vue';
import OrderReferenceSearchBox from '../../_components/OrderReferenceSearchBox.vue';

export default {
  name: 'IrOrderReship',

  components: {
    OrderForm,
    ShippingLabelsViewer,
    OrderReferenceSearchBox,
  },

  data() {
    return {
      searchTerm: '',
      showOrderForm: false,
      printProviderId: null,
      returnedLabels: { shippingLabels: [] },
    };
  },

  computed: {
    ...mapState('reship', ['reshipOrderProviders']),

    ...mapGetters('accounts', ['providersOptions']),

    reshipOrder() {
      return this.printProviderId
        ? this.reshipOrderProviders
          .find(({ printProviderId }) => printProviderId === this.printProviderId)
        : this.reshipOrderProviders[0];
    },

    reshipProviders() {
      return this.reshipOrderProviders.map(({ printProviderId }) => printProviderId);
    },

    providers() {
      const ids = this.reshipProviders.filter(v => v);
      return this.providersOptions.filter(({ value }) => ids.length && ids.includes(value));
    },
  },

  created() {
    this.getAccounts();
  },

  methods: {
    ...mapActions('accounts', ['getAccounts']),

    ...mapMutations('reship', ['setReshipOrderProviders']),

    ...mapActions('reship', {
      getReshipOrder(dispatch) {
        if (this.searchTerm) {
          this.returnedLabels.shippingLabels = [];

          this.wrapToLoadingFn({
            req: dispatch.bind({}, 'getReshipOrderProviders', { searchTerm: this.searchTerm }),
            onSuccess: () => {
              this.showOrderForm = true;

              if (this.providers.length) {
                this.printProviderId = this.providers[0].value;
              }
            },
          });
        }
      },
    }),

    sendReshipOrder({ order }) {
      this.$VBlackerTheme.alert.warning({
        text: 'Generate reship label?',
      }, () => {
        const form = JSON.parse(JSON.stringify(order));

        form.packages.forEach((pack) => {
          if (pack.description) {
            pack.packageItems = [{ description: pack.description }];
          }

          delete pack.description;
        });

        this.wrapToLoadingFn({
          req: ReshipApiService.sendReshipOrder.bind({}, {
            orderId: this.reshipOrder.printProviderOrderId,
            form,
          }),
          onSuccess: (response) => {
            this.$VBlackerTheme.notification.success('Order successfully reshiped');
            this.returnedLabels = response;
            this.showOrderForm = false;
          },
        });
      });
    },

    resetForm() {
      this.searchTerm = '';
      this.showOrderForm = false;
      this.setReshipOrderProviders([createReshipOrder()]);
    },

    createReshipOrder,
    wrapToLoadingFn,
  },
};
</script>
